import React from "react";
import { useApp } from "@/context/AppContext";

export function BetaBanner() {
  const { branding } = useApp();
  if (!branding?.beta_mode) return null;
  return (
    <div data-testid="beta-banner" className="sticky top-0 z-50 bg-[#FFB81C] text-[#003284] text-center text-sm font-bold px-4 py-2 leading-snug">
      {branding.beta_message || "Versión beta · Los precios son provisionales y las inscripciones se abrirán próximamente."}
    </div>
  );
}
